import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IRecommendOrderRepository } from '@/coreInfrastructureModule/interfaces/IRecommendOrderRepository';

/**
 * 推奨発注情報を持つ集計ID一覧を取得する
 */
export class GetAggregateBusinessIdsRecommendOrderListUseCase {
  private repository: IRecommendOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IRecommendOrderRepository) {
    this.repository = repository;
  }

  /**
   * 推奨発注情報を持つ集計ID一覧を取得する
   */
  public Execute(): INetworkResult<string[], IError> {
    try {
      const response = this.repository.get();
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: response.status.data,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
